import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const QuoteToProductionRoute: RouteType = {
  name: "Quote to Production",
  path: "/purchasing/quote-to-production",
  layout: "/app",
  group: "Purchasing",
  requiresAuth: true,
  hidden: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Quote to Production Conversion",
      component: () => import("./QuoteToProductionHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./QuoteToProductionBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const quotesStore = rootStore.manholeQuotesStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const productionOrdersStore =
        rootStore.productionOrdersStore as ServiceStore;

      if (quotesStore) {
        await quotesStore.find();
      }

      if (productsStore) {
        await productsStore.find();
      }

      if (productionOrdersStore) {
        await productionOrdersStore.find({ query: { $limit: 50 } });
      }

      return true;
    } catch (error) {
      console.error("Failed to load data for quote conversion:", error);
      return true;
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).quoteToProductionViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default QuoteToProductionRoute;
